import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type AllAmbassadorsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AllAmbassadorsQuery = {
  __typename?: 'Query';
  allUsers?: Array<{
    __typename?: 'User';
    id: string;
    distance?: number | null;
    name?: string | null;
    surname?: string | null;
    isSmallOrganisation?: boolean | null;
    anonymised?: boolean | null;
    businessName?: string | null;
    isProGold?: boolean | null;
    role: Types.UserRole;
    sharrylandPartner: boolean;
    workAddress?: string | null;
    whoIAm?: string | null;
    slug?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ambassador?: boolean | null;
    isPaladin?: boolean | null;
    friendlyMunicipality?: boolean | null;
    province?: string | null;
    municipality?: string | null;
    bookmarked?: boolean | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
  }> | null;
};

export const AllAmbassadorsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allAmbassadors' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'query' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'field' },
                            value: { kind: 'StringValue', value: 'ambassador', block: false },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'comparator' },
                            value: { kind: 'EnumValue', value: 'is_true' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardUser' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surname' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anonymised' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '160x160', block: false },
                    },
                  ],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualification' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workAddress' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFollow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whoIAm' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ambassador' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isPaladin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'friendlyMunicipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookmarked' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AllAmbassadorsGQL extends Apollo.Query<AllAmbassadorsQuery, AllAmbassadorsQueryVariables> {
  document = AllAmbassadorsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
